<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-pixels
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-chart-pie mr-2'></i> Pixels</h4>"
          v-else
        ></table-pixels>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TablePixels from "./TablePixels";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import ModalCreatePartner from "../notifications/ModalCreatePartner";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "partners",
  components: {
    TablePixels,
    SemipolarSpinner,
    ModalCreatePartner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "pixel_code", label: "Codigo de pixel", sortable: true },
        { key: "account_ids", label: "Cuentas" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getAllPixels();
  },
  methods: {
    getAllPixels() {
      var pixels = store.getters.getAllPixels;
      if (pixels.length == 0) {
        this.isLoading = true;
        store.dispatch("getAllPixels").then(() => {
          pixels = store.getters.getAllPixels;
          shuffleArray([pixels]);
          this.isLoading = false;
          this.items = pixels;
          this.itemsArray = pixels;
        });
      } else {
        shuffleArray([pixels]);
        this.items = pixels;
        this.itemsArray = pixels;
      }
    }
  }
};
</script>
